"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trash = Trash;
var _react = _interopRequireDefault(require("react"));
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function Trash({
  color,
  size = 1,
  variant = 'solid'
}) {
  if (variant === 'solid') {
    return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
      heightAndWidth: size,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
      d: "M15 4.999V3H9v1.999H3v2h18v-2zM5 7.999v12c0 1.102.897 2 2 2h10c1.103 0 2-.898 2-2v-12H5zM11 18H9v-6h2v6zm4 0h-2v-6h2v6z",
      fillColor: color
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
    heightAndWidth: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
    d: "M5 20c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V8H5v12zm2-10h10l.001 10H7V10zM15 5V3H9v2H3v2h18V5z",
    fillColor: color
  }));
}